import React from 'react';
import LastLoginWidget from './LastLoginWidget';

const LastLoginWidgetBasic = () => (
  <LastLoginWidget className="masonry-item w-[380px] h-[300px] flex flex-col" />
);

export default LastLoginWidgetBasic;
